// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lx-1";
export var messageSideRight = "_lx-2";
export var orderLookupBubbleContainer = "_lx-0";
export var submitButton = "_lx-3";